const Identity = {};

Identity.ID = () => {
	return 17;
};

export default Identity;
